import gql from "graphql-tag";
import { companyFragment } from '@/graphql/company/companyFragments'

export const UPDATECOMPANY = gql`
    mutation updateCompany(
        $id: ID!
        $name: String
        $primary_phone: String
        $contact_email: String
        $secondary_phone: String
        $fax: String
        $street: String
        $town: String
        $state: String
        $country: String
        $zipcode: String
        $website: String
        $categories: [ID]
    ){
        updateCompany(
            input: {
                id: $id
                name: $name
                primary_phone: $primary_phone
                contact_email: $contact_email
                secondary_phone: $secondary_phone
                fax: $fax
                street: $street
                town: $town
                state: $state
                country: $country
                zipcode: $zipcode
                website: $website
                categories: {sync: $categories}
                # isMainCompany: $isMainCompany
            }
        ){
            ...companyFragment
        }
    }
    ${companyFragment}
`;
export const UPSERTCOMPANY = gql`
    mutation upsertCompany(
        $id: ID
        $name: String
        $primary_phone: String
        $contact_email: String
        $secondary_phone: String
        $fax: String
        $street: String
        $town: String
        $state: String
        $country: String
        $zipcode: String
        $website: String
        $categories: [ID]
    ){
        upsertCompany(
            input: {
                id: $id
                name: $name
                primary_phone: $primary_phone
                contact_email: $contact_email
                secondary_phone: $secondary_phone
                fax: $fax
                street: $street
                town: $town
                state: $state
                country: $country
                zipcode: $zipcode
                website: $website
                categories: {sync: $categories}
                # isMainCompany: $isMainCompany
            }
        ){
            ...companyFragment
        }
    }
    ${companyFragment}
`;

export const DELETECOMPANY = gql`
    mutation deleteCompany(
        $id: ID!
    ){
        deleteCompany(
            id: $id
        ){
            ...companyFragment
        }
    }
    ${companyFragment}
`



export const RESTORERECOMPANY = gql`
    mutation restoreCompany(
        $id: ID!
    ){
        restoreCompany(
            id: $id
        ){
            ...companyFragment
        }
    }
    ${companyFragment}
`
